// This file is generated by ThemeBuilder.ts : DO NOT MODIFY

export default {"theme-default":{"dark":false,"colors":{"background":"#f1f3f5","surface":"#d7e0f0","primary":"#ff4a63","secondary":"#368f8b","error":"#ff4a63","info":"#2196F3","success":"#368f8b","warning":"#FB8C00","gray":"#656d95"}}};